export const GIFT_PRICE: number = 500;
export const AMBASSADOR_PAGE_URL: string = 'https://contentoo.com/ambassador-program/';
